<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Participant Enrollment</h1>
            <!-- <div class="action">
                <ppl-button label="Create New Participant Enrollment" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" [authorizeButton]="[pageId, 'NewParticipantEnrollment']"
                    (click)="onNewEnrollment()"></ppl-button>
            </div> -->
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table
                        [pageConfig]="programName"
                        [sharedDataKey]="sharedDataKey"
                        (rowDetailEvent)="rowClicked($event)"
                        [loadPage]="lazyLoad"
                        [columnsToBeHidden]="columnsToBeHidden"
                        [actionsToBeHidden]="actionsToBeHidden"
                        [jsonList]="'list_participant_enrollments'"
                        [enablePageActions]="true"
                        rowDataAccessibilityKey="participant_ppl_id"
                        [searchDropdownValues]="contactStsReasonLkpList"
                        [showColumnFilters]="true"
                        [badgeColumns]="['Has Email', 'Has Mobile or Telephone', 'Application Status']"
                        >
                    </ppl-list-table>
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>
